module.exports = __webpack_public_path__ + "resource/img/image029Dark.600d9da3.png";